import { medusaClient } from "./config";

export const fetchAllProducts = async (sort, limit, offset) => {
  const params = {
    limit:99999,
    offset:0
  };
  if (sort === "latest") params["order"] = "-created_at";
  else if (sort?.includes("price")) params["description"] = sort;
  // else if (sort?.includes("popular")) {
  //   params["expand"] = "tags,variants,variants.prices,collection,categories";
  // }

  params["expand"] = "tags,variants,variants.prices,collection,categories";
  const { products,count } = await medusaClient.products.list(params);
  if (!products.length) {
    throw new Error("Network response was not ok");
  }

  if (sort?.includes("popular")) {
    try {
      const sortedProducts = sortByFeaturedTag(products);
      const sorted = sortedProducts.slice(offset, offset + limit);
      return [sorted,count];
    } catch (err) {
      return [products.slice(offset, offset + limit),count];
    }

    // return sortedProducts.slice(offset, offset + limit);
  } else return [products.slice(offset, offset + limit),count];
};


export const fetchLatestProducts = async (limit = 4, offset = 0) => {
  const { products = [], count = 0 } = await medusaClient.products.list({
    limit,
    offset,
    order: "-created_at",
    expand: "tags,variants,variants.prices,collection,categories",
  });

  return [products, count];
};

export const fetchProductsByTagValue = async (
  tagValue,
  limit = 8,
  offset = 0,
  sort = "latest"
) => {
  const { product_tags } = await medusaClient.productTags.list({
    value: tagValue,
    limit: 1,
  });
  const tagId = product_tags?.[0]?.id;

  if (!tagId) return [[], 0];

  const params = {
    limit,
    offset,
    tags: [tagId],
    expand: "tags,variants,variants.prices,collection,categories",
  };

  if (sort === "latest") params["order"] = "-created_at";

  const { products = [], count = 0 } = await medusaClient.products.list(params);

  return [products, count];
};

export const fetchProductsByOrderedTagValues = async (tagValues = []) => {
  const results = await Promise.all(
    tagValues.map((tagValue) =>
      fetchProductsByTagValue(tagValue, 1, 0, "none")
    )
  );

  return results.flatMap(([products]) => products.slice(0, 1));
};

export const fetchPrioritizedLatestProducts = async (
  tagValue = "new-priority",
  limit = 8
) => {
  const [latestResult, priorityResult] = await Promise.allSettled([
    fetchLatestProducts(limit, 0),
    fetchProductsByTagValue(tagValue, limit, 0),
  ]);

  if (latestResult.status === "rejected" && priorityResult.status === "rejected") {
    throw latestResult.reason;
  }

  const [latestProducts, latestCount] =
    latestResult.status === "fulfilled" ? latestResult.value : [[], 0];
  const [priorityProducts] =
    priorityResult.status === "fulfilled" ? priorityResult.value : [[], 0];

  const seen = new Set();
  const products = [...priorityProducts, ...latestProducts].filter((product) => {
    const key = product?.id || product?.handle;
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  return [products.slice(0, limit), latestCount];
};

export const fetchProducts = async (slug, sort,limit,offset) => {
  const { collections } = await medusaClient.collections.list({
    handle: [slug],
  });
  const params = {
    limit: 99999,
    offset: 0,
    collection_id: [collections?.[0]?.id],
  };
  if (sort === "latest") params["order"] = "-created_at";
  else if (sort?.includes("price")) params["description"] = sort;
  // else if (sort?.includes("popular")) {
  //   params["expand"] = "tags,variants,variants.prices,collection,categories";
  // }
  params["expand"] = "tags,variants,variants.prices,collection,categories";
  const { products,count } = await medusaClient.products.list(params);
  if (!products.length) {
    throw new Error("Network response was not ok");
  }

  if (sort?.includes("popular")) {
    try {
      const sortedProducts = sortByFeaturedTag(products);
      const sorted = sortedProducts.slice(offset, offset + limit);
      return [sorted,count];
    } catch (err) {
      return [products.slice(offset, offset + limit),count];
    }

    // return sortedProducts.slice(offset, offset + limit);
  } else return [products.slice(offset, offset + limit),count];
};

function sortByFeaturedTag(products) {
  return products.sort((a, b) => {
    const hasFeaturedA = a.tags.some((t) => t.value === "featured");
    const hasFeaturedB = b.tags.some((t) => t.value === "featured");

    // Prioritize products with the "featured" tag
    if (hasFeaturedA && !hasFeaturedB) {
      return -1;
    } else if (!hasFeaturedA && hasFeaturedB) {
      return 1;
    } else {
      // If both have or neither have the "featured" tag, maintain original order
      return 0;
    }
  });
}
export const fetchCollections = async () => {
  const { collections } = await medusaClient.collections.list({ limit: 99 });
  if (!collections.length) {
    throw new Error("Network response was not ok");
  }
  return collections;
};
